var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "root" },
    [
      _c(
        "w-card-content",
        [
          _c("app-product-edit-row", {
            attrs: {
              "contact-discount": _vm.discount,
              lng: _vm.lng,
              "price-category": _vm.priceCategory,
              row: _vm.editRow,
              "vat-regime": _vm.vatRegime,
              state: _vm.editRowState,
            },
            on: {
              add: function ($event) {
                return _vm.onAddRow($event)
              },
              "search-products": _vm.searchProducts,
              "product-selected": function ($event) {
                return _vm.$emit("product-selected", $event)
              },
              "products-selected": function ($event) {
                return _vm.onMultipleProductsSelected($event)
              },
              "unit-price-key-down": function ($event) {
                return _vm.$emit("unit-price-key-down", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("app-products-table", {
        attrs: { items: _vm.items, "selected-row": _vm.selectedRow },
        on: {
          add: _vm.insertRowBefore,
          edit: function ($event) {
            return _vm.onEdit($event)
          },
          remove: function ($event) {
            return _vm.onRemove($event)
          },
          select: function ($event) {
            return _vm.onRowSelect($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }